module.exports = __webpack_public_path__ + "rt-icons-2.bdfaa56bda2f522e79bf.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/fonts/rt-icons-2.ttf?wz19bt
// module id = ../../../../../src/fonts/rt-icons-2.ttf?wz19bt
// module chunks = styles